(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive-infographic-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wi-editorial]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const revealItems = root.querySelectorAll('.wi-reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.12 });
      revealItems.forEach((item) => observer.observe(item));
    } else revealItems.forEach((item) => item.classList.add('is-visible'));
    root.querySelectorAll('.wi-ingredient').forEach((ingredient) => ingredient.addEventListener('click', () => {
      const expanded = ingredient.getAttribute('aria-expanded') === 'true';
      ingredient.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
